import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const items = [
  {
    title: 'Fuerza visual',
    text: 'Los inserts y el logo en los Reels garantizan que el espectador identifique a Papaupa de inmediato.',
  },
  {
    title: 'Repetición estratégica',
    text: 'Rotativa y menciones convierten «Un pedacito de cielo» en sinónimo de la marca en audio y video.',
  },
  {
    title: 'Contenido compartible',
    text: 'La rotativa (micros) y las piezas de redes son material profesional que Papaupa puede usar en sus propias plataformas.',
  },
];

const WhySection = () => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 6 }}>
      <Typography variant="h4" fontWeight={700} color="primary" gutterBottom align="center">
        Por qué este plan multi-pantalla
      </Typography>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={item.title}>
            <Box
              sx={{
                p: 2.5,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="subtitle1" fontWeight={800} color="secondary.dark" gutterBottom>
                {i + 1}. {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.75 }}>
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WhySection;
